export default "__VITE_ASSET__B4jtWe8k__"